import { createAction } from 'typesafe-actions';

import { actions as SmartConversionActions } from '../constants/SmartConversion';

type SetTrackingEventsParams = $TSFixMe;

interface SetTrackingEventsPayload {
  trackingEvents: SetTrackingEventsParams | Record<string, never>;
}

export const setTrackingEvents = createAction(
  SmartConversionActions.SET_TRACKING_EVENTS,
  (trackingEvents: SetTrackingEventsParams) => ({ trackingEvents }),
)<SetTrackingEventsPayload>();

export const clearTrackingEvents = createAction(SmartConversionActions.SET_TRACKING_EVENTS, () => ({
  trackingEvents: {},
}))<SetTrackingEventsPayload>();
export type SetTrackingEventsAction = ReturnType<
  typeof setTrackingEvents | typeof clearTrackingEvents
>;

type TriggerSmartConversionUpsellParams = $TSFixMe;

interface TriggerSmartConversionUpsellPayload {
  event: TriggerSmartConversionUpsellParams;
}

export const triggerUpsell = createAction(
  SmartConversionActions.TRIGGER_SMART_CONVERSION_UPSELL,
  (event: TriggerSmartConversionUpsellParams) => ({ event }),
)<TriggerSmartConversionUpsellPayload>();
export type TriggerSmartConversionUpsellAction = ReturnType<typeof triggerUpsell>;

type LaunchSmartConversionProductParams = $TSFixMe;

interface LaunchSmartConversionProductPayload {
  product: LaunchSmartConversionProductParams;
}

export const launchProductOffering = createAction(
  SmartConversionActions.LAUNCH_SMART_CONVERSION_PRODUCT,
  (product: LaunchSmartConversionProductParams) => ({ product }),
)<LaunchSmartConversionProductPayload>();
export type LaunchSmartConversionProductAction = ReturnType<typeof launchProductOffering>;
